import CONST from '@/utils/Constants/General';

export const getLabelOriginByBrand = () => {
  switch (DLG.config.brand) {
    case CONST.BRAND.BRAUN:
      return new google.maps.Point(12, 12);
    case CONST.BRAND.KENWOOD:
      return new google.maps.Point(14, 14);
    default:
      return new google.maps.Point(12, 12);
  }
};

export const getFontFamilyByBrand = () => {
  switch (DLG.config.brand) {
    case CONST.BRAND.BRAUN:
      return 'BraunLinear-Bold';
    case CONST.BRAND.KENWOOD:
      return 'Montserrat Semibold';
    default:
      return 'Helvetica Neue Bold';
  }
};

export const getWindowSizeByBrand = () => {
  switch (DLG.config.brand) {
    case CONST.BRAND.BRAUN:
      return 325;
    case CONST.BRAND.KENWOOD:
      return 335;
    default:
      return 325;
  }
};

export const getIconPinByBrand = () => {
  switch (window.DLG.config.brand) {
    case CONST.BRAND.BRAUN:
      return `${CONST.PATH.ASSETS.IMAGES}/icons/icon-pin-brand-01.svg`;
    case CONST.BRAND.KENWOOD:
      return `${CONST.PATH.ASSETS.IMAGES}/icons/icon-pin-brand-01-kenwood.svg`;
    default:
      return `${CONST.PATH.ASSETS.IMAGES}/icons/icon-pin-brand-01.svg`;
  }
};
